import Vue from 'vue'
import Vuex from 'vuex'
// Store modules
import staff from './modules/staff'
import smeFireInsurance from './modules/smeFireInsurance'
import quickquote from './modules/quickquote'
import disaster from './modules/disaster'
import carInsurance from './modules/carInsurance'
import address from './modules/address'
import ttb from './modules/ttb'
import notification from './modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    staff,
    ttb,
    notification,
    address,
    carInsurance,
    smeFireInsurance,
    quickquote,
    disaster,
  },
  strict: process.env.NODE_ENV !== 'production',
})
